import {
    chakra,
    keyframes,
    shouldForwardProp
} from '@chakra-ui/react';
import type { ChakraStyledOptions } from '@chakra-ui/system/src/system';
import type { ElementType } from 'react';

import type { LoaderDotsProps } from './loader-dots';

export const DEFAULT_TOTAL_DOTS = 7;

const dotKeyframes = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.3);
    background: #59CD90;
  }
  25% {
    opacity: 1;
    transform: scale(1.8);
    background: #0072BB;
  }
  50% {
    opacity: 0;
    transform: scale(0.3);
    background: #FE4A49;
  }
  75% {
    opacity: 1;
    transform: scale(1.8);
    background: #FED766;
  }
  100% {
    opacity: 0;
  }
`;
const createDotAnimations = ({
    totalDots = DEFAULT_TOTAL_DOTS, duration
}: LoaderDotsProps) => {
    return Object.fromEntries(Array.from(Array(totalDots)).map(
        (_, index) => {
            const delay = totalDots / ((totalDots + 1) - index);

            return [
                `div:nth-of-type(${index + 1})`,
                {
                    animationDuration: `${duration}s`,
                    animationDelay: `${delay}s`,
                    animationName: `${dotKeyframes}`,
                    animationTimingFunction: 'linear',
                    animationIterationCount: 'infinite'
                }
            ];
        })
    );
};
const PreventForwardingPropList = [
    'duration',
    'dotSpacing',
    'dotSize',
    'totalDots'
];

export const LoaderDotAnimation = chakra('div', {
    baseStyle: (props: LoaderDotsProps) => ({
        position: 'relative',
        display: 'flex',
        div: {
            borderRadius: '50%',
            ...props.dotSize && {
                minHeight: `${props.dotSize}px`,
                minWidth: `${props.dotSize}px`
            },
            ...props.dotSpacing && {
                'marginRight': `${props.dotSpacing}px`,
                '&:last-child': { marginRight: '0 !important' }
            }
        },
        ...createDotAnimations(props)
    }),
    shouldForwardProp: (prop: string) => {
        return !PreventForwardingPropList.includes(prop) && shouldForwardProp(prop);
    }
} as any as ChakraStyledOptions) as ElementType<LoaderDotsProps>;
